import { Outlet } from '@tanstack/react-router'
import { AuthenticatedLayout } from '@/components/layout/AuthenticatedLayout'
import Sidebar from '@/components/layout/Sidebar'

/** The full app chrome: sidebar and the routed page. `AuthFullLayout` adds the Theragenie dock. */
export function FullLayout() {
  return (
    <AuthenticatedLayout>
      <div className="flex h-screen bg-[#F8F9FC] overflow-hidden">
        <Sidebar />
        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
          {/* Top-level Navbar (search bar / notifications / app name)
              has been removed app-wide.  Pages that need a header should
              render their own page-specific header inside the page. */}
          <main className="flex-1 overflow-y-auto p-4 scrollbar-hidden">
            <Outlet />
          </main>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
